import React from 'react'
import {Box, Text} from '@chakra-ui/react'
import {useContentAsset} from '../../hooks/useScapiCustomApi'
import CopyOnly from './copy-only'
import PropTypes from 'prop-types'
import LoadingSpinner from '../../components/loading-spinner'
import TeaserList from './teaser-list'
import Hero from './hero'
import ProductAnimated from './product-animated'
import Awards from './awards'
import ModuleErrorBoundary from './module-error-boundary'
import Carousel from './carousel'
import Accordion from './accordion'
import Gallery from './gallery'
import Cards from './cards'
import HighlightStack from './highlight-stacks'
import ProductColors from './product-colors'

const MODULES_MAP = {
    'leap-copy-only': CopyOnly,
    'leap-teaser-list': TeaserList,
    'leap-hero': Hero,
    'leap-product-animated': ProductAnimated,
    'leap-product-colors': ProductColors,
    'leap-awards': Awards,
    'leap-carousel': Carousel,
    'leap-accordion': Accordion,
    'leap-gallery': Gallery,
    'leap-cards': Cards,
    'leap-highlights-stack': HighlightStack
}

const CmsModules = ({assetId, modules: preloadedModules}) => {
    const {data: modules, isLoading} = useContentAsset(
        {parameters: {assetId}},
        {enabled: !preloadedModules, initialData: preloadedModules}
    )

    if (isLoading) {
        return <LoadingSpinner />
    }

    if (typeof modules?.map !== 'function') {
        return null
    }

    return modules.map(({moduleType, ...module}, index) => {
        const Module = MODULES_MAP[moduleType]

        if (!Module) {
            return (
                <Box key={index} border="1px solid red" p={4} m={4}>
                    <Text color="red">
                        <span>Unsupported module type&nbsp;</span>
                        <strong>{moduleType}</strong>
                        <span>&nbsp;from content asset</span>
                        <strong>{assetId}</strong>
                        <span>&nbsp;position&nbsp;</span>
                        <strong>{index + 1}</strong>
                    </Text>
                    <Text as="pre" bg="red">
                        {JSON.stringify(module, null, 2)}
                    </Text>
                </Box>
            )
        }

        return (
            <ModuleErrorBoundary
                key={index}
                moduleType={moduleType}
                assetId={assetId}
                position={index + 1}
                moduleConfig={module}
            >
                <Module {...module} moduleType={moduleType} />
            </ModuleErrorBoundary>
        )
    })
}

CmsModules.propTypes = {
    assetId: PropTypes.string,
    modules: PropTypes.array
}

export default CmsModules
